module.exports = __webpack_public_path__ + "img/member.b33bbad2.svg";